export default __webpack_public_path__ + "static/use_case_posting-db111a407e1316c589935e8e1ffb38c2.gif";